// React
import React from 'react';
import PropTypes from 'prop-types';
// Locales
import translate from 'locales/i18n';
// Material UI
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import DoneIcon from '@mui/icons-material/Done';
import RefreshIcon from '@mui/icons-material/Replay';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// Currencies
import currencies from 'currencies.js';

class DialogSPEConfiguration extends React.PureComponent {

    static propTypes = {
        close: PropTypes.func,
        open: PropTypes.bool,
        trustAlertThreshold: PropTypes.number,
        robot: PropTypes.string,
        currency: PropTypes.string,
        tax: PropTypes.string,
        bwRef: PropTypes.bool,
        bwConfig: PropTypes.bool,
        maxParallelWorkers: PropTypes.number,
        scrapingControlDuration: PropTypes.number,
        comment: PropTypes.string,
        handleChangeSiteConfiguration: PropTypes.func,
        restoreDefaultSettings: PropTypes.func,
        siteName: PropTypes.string,
        classes: PropTypes.object,
        fullScreen: PropTypes.bool,
        isMarketplace: PropTypes.bool,
    };

    render() {
        const { fullScreen, classes, isMarketplace, robot, trustAlertThreshold, currency, tax, bwRef, bwConfig, comment, maxParallelWorkers, scrapingControlDuration, siteName } = this.props;

        return (
            <Dialog
                fullScreen={fullScreen}
                open={this.props.open}
                onClose={this.props.close}
                disableRestoreFocus={true}
                aria-labelledby='responsive-dialog-title'
                classes={{
                    paper: classes.dialogPaper
                }}
            >
                <DialogTitle id='responsive-dialog-title' className={classes.dialogTitle}>{translate.i18n('ADD_SPE_CONFIG_FOR', { siteName })}</DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <TextField
                        label={translate.i18n('TRUST_ALERT_THRESHOLD')}
                        type='number'
                        value={trustAlertThreshold}
                        variant='outlined'
                        className={classes.textField}
                        InputProps={{ inputProps: { min: 0, max: 1, step: 0.01 } }}
                        onChange={event => this.props.handleChangeSiteConfiguration('trustAlertThreshold', parseFloat(event.target.value))}
                    />
                    <TextField
                        label={translate.i18n('MAX_PARALLEL_WORKERS')}
                        type='number'
                        value={maxParallelWorkers}
                        variant='outlined'
                        InputProps={{ inputProps: { min: 0 } }}
                        className={classes.textField}
                        onChange={event => this.props.handleChangeSiteConfiguration('maxParallelWorkers', parseFloat(event.target.value))}
                    />
                    <TextField
                        label={translate.i18n('SCRAPING_CONTROL_DURATION')}
                        type='number'
                        value={scrapingControlDuration}
                        variant='outlined'
                        InputProps={{ inputProps: { min: 0 } }}
                        className={classes.textField}
                        onChange={event => this.props.handleChangeSiteConfiguration('scrapingControlDuration', parseFloat(event.target.value))}
                    />
                    <FormControl variant='outlined'
                        classes={{
                            root: classes.formControl
                        }}>
                        <InputLabel
                            htmlFor='outlined'
                            margin={'dense'}>
                            {translate.i18n('ROBOT_VERSION')}
                        </InputLabel>
                        <Select
                            value={robot}
                            onChange={event => this.props.handleChangeSiteConfiguration('robot', event.target.value)}
                            label={translate.i18n('ROBOT_VERSION')}
                        >
                            <MenuItem value={'NONE'}>None</MenuItem>
                            <MenuItem value={'AMAZON'}>Amazon</MenuItem>
                            <MenuItem value={'V2.9'}>v2.9</MenuItem>
                            <MenuItem value={'V3'}>v3.0</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl variant='outlined'
                        classes={{
                            root: classes.formControl
                        }}>
                        <InputLabel
                            htmlFor='outlined'
                            margin={'dense'}>
                            {translate.i18n('CURRENCY')}
                        </InputLabel>
                        <Select
                            value={currency}
                            onChange={event => this.props.handleChangeSiteConfiguration('currency', event.target.value)}
                            label={translate.i18n('CURRENCY')}
                        >
                            {currencies.map((c, key) => <MenuItem value={c.code} key={key}>{c.symbol + ' (' + c.name + ')'}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControl variant='outlined'
                        classes={{
                            root: classes.formControl
                        }}>
                        <InputLabel
                            htmlFor='outlined'
                            margin={'dense'}>
                            {translate.i18n('TAX_MODE')}
                        </InputLabel>
                        <Select
                            value={tax}
                            onChange={event => this.props.handleChangeSiteConfiguration('tax', event.target.value)}
                            label={translate.i18n('TAX_MODE')}
                        >
                            <MenuItem value={'INCL'}>{translate.i18n('TAXES_INCLUDED')}</MenuItem>
                            <MenuItem value={'EXCL'}>{translate.i18n('TAXES_EXCLUDED')}</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        className={classes.textField}
                        id='outlined-multiline-static'
                        label={translate.i18n('COMMENT')}
                        multiline
                        rows={4}
                        value={comment}
                        variant='outlined'
                        onChange={event => this.props.handleChangeSiteConfiguration('comment', event.target.value)}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={bwRef}
                                onChange={event => this.props.handleChangeSiteConfiguration('bwRef', event.target.checked)}
                                name='BW REF'
                                color='primary'
                            />
                        }
                        label={'BW REF'}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={bwConfig}
                                onChange={event => this.props.handleChangeSiteConfiguration('bwConfig', event.target.checked)}
                                name='BW CONFIG'
                                color='primary'
                            />
                        }
                        label={'BW CONFIG'}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={isMarketplace}
                                onChange={() => this.props.handleChangeSiteConfiguration('isMarketplace', !isMarketplace)}
                                name='isMarketplace'
                                color='primary'
                            />
                        }
                        label={translate.i18n('IS_MARKET_PLACE')}
                    />
                    <Button
                        variant='outlined'
                        color='primary'
                        onClick={this.props.restoreDefaultSettings}>
                        {translate.i18n('DEFAULT_SETTINGS')}
                        <RefreshIcon className={classes.rightIcon} />
                    </Button>
                </DialogContent>
                <DialogActions>
                    <IconButton color='primary' onClick={this.props.close}>
                        <DoneIcon />
                    </IconButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = () => ({
    dialogContent: {
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '10%',
        paddingRight: '10%',
        padding: 0,
        minWidth: '300px'
    },
    dialogPaper: {
        minWidth: '25%'
    },
    dialogTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: '5px'
    },
    textField: {
        marginTop: '16px'
    },
    formControl: {
        marginTop: '16px'
    },
    rightIcon: {
        marginLeft: '8px',
        fontSize: 20
    }
});

export default withStyles(styles)(DialogSPEConfiguration);
